module.exports = __webpack_public_path__ + "static/media/noticia5.c71d4291.jpg";